import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=1c1e35b3"
import script from "./Action.vue?vue&type=script&lang=js"
export * from "./Action.vue?vue&type=script&lang=js"
import style0 from "./Action.vue?vue&type=style&index=0&id=1c1e35b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports